export class FolderFilter {
  constructor(id) {
    this.id = id;
  }

  static fromServerModel(data) {
    return new FolderFilter(data.id);
  }

  toServerModel() {
    return { id: this.id };
  }
}

export class FolderFilters {
  constructor(folderFilters = []) {
    this.folderFilters = folderFilters;
  }

  static fromServerModel(data = []) {
    const folderFilters = data.map((item) =>
      FolderFilter.fromServerModel(item)
    );
    return new FolderFilters(folderFilters);
  }

  toServerModel() {
    return this.folderFilters.map((ff) => ff.toServerModel());
  }

  prune(folderTree) {
    const getLeafIds = (node) => {
      if (node.children && node.children.length > 0) {
        return node.children.reduce(
          (acc, child) => acc.concat(getLeafIds(child)),
          []
        );
      }
      return [node.value];
    };

    const findFolderById = (nodes, id) => {
      for (const node of nodes) {
        if (node.value === String(id)) return node;
        if (node.children && node.children.length > 0) {
          const found = findFolderById(node.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const leafIdSet = new Set();
    this.folderFilters.forEach((ff) => {
      const node = findFolderById(folderTree, ff.id);
      if (node) {
        const leafIds = getLeafIds(node);
        leafIds.forEach((id) => leafIdSet.add(String(id)));
      } else {
        leafIdSet.add(String(ff.id));
      }
    });

    const pruned = Array.from(leafIdSet).map(
      (id) => new FolderFilter(Number(id))
    );
    return new FolderFilters(pruned);
  }
}
